<template>
  <div style="display: inline-flex;">
    <div style="display: flex; flex-direction: column; align-items: center">
      <div class="verify-hint">Verify LegitDoc - MSBSD certificates <span class="help-link">( <a class="link-underline" @click="openHelp">Need help?</a> )</span></div>
      <div class="verify-box" style="margin-top: 15px; position: relative">
        <div class="dragdrop">
          <img src="@/assets/dragdrop.png" alt="" style="width: 40px; "/>
          <div style="color: rgb(0,60,180)">
            Drag and Drop
          </div>
        </div>
        <div class="arrow">
          <div class="arrow-up"></div>
          <div class="arrow-down"></div>
        </div>
        <div class="select-files" @click="chooseFiles">
          <div
              class="select-btn"
          >
            <span style="font-weight: 600">Select File</span>
            <v-icon
                right
                dark
                style="color: inherit"
            >mdi-plus-circle-outline
            </v-icon>
          </div>
        </div>
        <div class="upload-btn-wrapper" style="display:none">
          <input id="choose_files" type="file" multiple="multiple" accept=".pdf"
                 @change="selectFiles">
        </div>
      </div>

    </div>
    <div id="drop_overlay" style="display:flex; justify-content: center;">
      <h3 style="margin-top: 100px">You can drop it now :)</h3>
    </div>
  </div>
</template>

<script>
import {makeDragAndDroppable} from '@/utils/ui-helper';
import {isIE11} from "@/assets/utils";
import VerifierStage from '@/store/support/verifier/VerifierStage';

export default {
  name: 'VerifierBoxUI',
  created() {
    //load the web worker ahead of use. Helps not load the worker from network when required.
    this.$store.dispatch('verifier/runDummyVerification');
  },
  mounted() {
    makeDragAndDroppable(document.getElementById('app'), this.selectFiles.bind(this),
        document.getElementById('drop_overlay'));
  },
  computed: {
    verificationStageName() {
      return this.$store.state.verifier.stage.name;
    },
    inChoosingStage() {
      return this.verificationStageName === VerifierStage.CHOOSE.name;
    },
    inGeneratedReportsStage() {
      return this.verificationStageName === VerifierStage.GENERATED_REPORTS.name;
    },
  },
  methods: {
    resetSession() {
      this.$store.dispatch('verifier/resetVerification');
    },
    async selectFiles(e) {
      if (isIE11()) {
        this.$toast.error('Please use Google Chrome or Firefox for verifying the documents', 'Browser not supported', {
          timeout: false,
          position: "center",
          color: "blue",
          overlay: true
        });
        return;
      }
      if (!this.inChoosingStage) {
        if (this.inGeneratedReportsStage) { //If verification is complete and reports are generated, can reset session and continue forward.
          this.resetSession();
        } else {
          this.$toast.error("Please try after the current verification session is complete", "Session in progress");
          return;
        }
      }
      const files = e.target.files || e.dataTransfer.files;
      if (files.length === 0) return;
      const pdfFiles = Array.from(files).filter(file => file.name.endsWith('.pdf'));
      if (pdfFiles.length === 0) {
        this.$toast.warning('Please choose LegitDoc pdf file for verification', "No pdf file found", {
          timeout: false,
          position: "topRight",
          color: "blue"
        });
        return;
      }
      if (pdfFiles.length > 1) {
        this.$toast.warning('You can only verify a single document at once.', 'Limit Exceeded', {
          timeout: false,
          position: "topRight",
          color: "blue"
        });
        return;
      }
      if (pdfFiles.length !== files.length) {
        const proceed = await this.$confirm("", `Only <b>${pdfFiles.length}</b> out of <b>${files.length} chosen files</b> are pdf files.
                        <br/> Do you want to continue with <b>${pdfFiles.length} pdf files</b>?`, "Continue", "Cancel");
        if (!proceed)
          return;
      }
      await this.$store.dispatch('verifier/hashFiles', pdfFiles);
    },
    chooseFiles() {
      document.getElementById('choose_files').click();
    },
    openHelp() {
      this.$root.$emit('open-help');
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";

$mobileBoxWidth: 300;
$boxWidth: 350;
$boxHeight: 200;
$border: 2;
$borderRadius: 30;
.verify-box {
  width: #{$boxWidth}px;
  height: #{$boxHeight}px;
  background: $primary-dark;
  border-radius: #{$borderRadius}px;
  display: flex;
  flex-direction: column;
  border: #{$border}px solid #c7d8eb;
}

.mobile .verify-box {
  width: #{$mobileBoxWidth}px;
}

.mobile .help-link {
  display: block;
}

.verify-hint {
  color: #000;
  font-weight: bold;
  font-size: 14px;
}

$dragDropHeight: 20;
.dragdrop {
  width: #{$boxWidth - $border*2}px;
  height: #{$boxHeight/2 + $dragDropHeight}px;
  border-radius: #{$borderRadius - $border*1.5}px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.mobile .dragdrop {
  width: #{$mobileBoxWidth - $border*2}px;
}

.select-files {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1
}

.select-btn {
  padding: 5px 20px;
  background: $secondary;
  border-radius: 20px;
  font-weight: lighter;
  color: $primary-dark !important;
}

.select-btn:hover {
  background: darken($primary-dark, 10%);
  color: $secondary !important;
  cursor: pointer;
}

.arrow {
  position: absolute;
  pointer-events: none;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: #{$boxWidth}px;
  height: #{$boxHeight}px;
  margin: auto;
  margin-top: #{$dragDropHeight}px;
  left: 0;
  top: 0;
}

.mobile .arrow {
  width: #{$mobileBoxWidth}px;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;

  border-bottom: 15px solid $primary-dark;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;

  border-top: 15px solid #fff;
}


#drop_overlay {
  visibility: hidden;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  pointer-events: none;
  height: 100%;
  background: rgba(0, 0, 0, 0.73);
  transition: visibility 175ms, opacity 175ms;
  color: #fff;
}


</style>
